import { render, staticRenderFns } from "./TbTrashXIcon.vue?vue&type=template&id=498f7679"
import script from "./TbTrashXIcon.vue?vue&type=script&lang=ts"
export * from "./TbTrashXIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports